import { OverlayTrigger, Tooltip, Popover } from "react-bootstrap";
const TooltipLink = ({
    id = Math.floor(Math.random() * 90000) + 10000,
    children,
    title = " ",
    placement = "top",
    ...restProps
}) => (
    <OverlayTrigger
        placement={placement}
        overlay={
            <Tooltip id={id}>
                <div className="text-start">{title}</div>
            </Tooltip>
        }
    >
        <a {...restProps}>{children}</a>
    </OverlayTrigger>
);
export default TooltipLink;
export const TooltipWrap = ({
    id = Math.floor(Math.random() * 90000) + 10000,
    children,
    title = " ",
    placement = "top",
    ...restProps
}) => (
    <OverlayTrigger
        placement={placement}
        overlay={
            <Tooltip id={id}>
                <div className="text-start">{title}</div>
            </Tooltip>
        }
    >
        <div {...restProps}>{children}</div>
    </OverlayTrigger>
);
export const PopoverWrap = ({
    id = Math.floor(Math.random() * 90000) + 10000,
    children,
    title = " ",
    placement = "top",
    trigger = ["hover", "focus"],
    ...restProps
}) => (
    <OverlayTrigger
        placement={placement}
        trigger={trigger}
        // show={true}
        overlay={
            <Popover
                id={id}
                className="bg-dark text-white px-1"
                style={{ width: "max-content" }}
            >
                <div className="px-1 py-1" style={{ width: "max-content" }}>
                    {title}
                </div>
            </Popover>
        }
    >
        <div {...restProps}>{children}</div>
    </OverlayTrigger>
);
